import { type FC, memo } from 'react';
import { useSearchParams } from 'react-router';
import { RecurringStatsGraph } from './RecurringStatsGraph';
import { RecurringStatsTable } from './RecurringStatsTable';

export const RecurringStats: FC = memo(() => {
  const [searchParams] = useSearchParams();
  const statsType = searchParams.get('statsType') ?? 'table';

  return statsType === 'table' ? (
    <RecurringStatsTable />
  ) : (
    <RecurringStatsGraph />
  );
});
